import React, { useRef } from 'react';
import { useSearchParams } from 'react-router';

import { isPathMatches } from '~/components/app-header/utils/navigation-utils';
import { useGetDocumentContextCounts } from '~/hooks/use-get-document-context-counts/useGetDocumentContextCounts';
import { useDocumentSearch } from '~/views/alfred/document-search/use-document-search/useDocumentSearch';

import { ChatInputComposer } from '../chat-input-composer/ChatInputComposer';
import { ChatInputConfig } from '../types';
import { useChatInputHandlers } from './useChatInputHandlers';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  chatContext?: {
    documents?: string[];
    documentTypes?: string[];
    entityTags?: string[];
  };
  config?: ChatInputConfig;
}

export const ChatDocumentSearch = ({
  submitCallback,
  chatContext,
  config,
}: ChatInputProps) => {
  const [params] = useSearchParams();

  const inputRef = useRef<HTMLTextAreaElement>(null);

  const { isMessagePending, messages } = useDocumentSearch(state => ({
    isMessagePending: state.isMessagePending,
    messages: state.messages,
  }));

  const isTargetPage = isPathMatches(['alfred', 'chart']);
  const isLoading = isTargetPage && isMessagePending;

  const handlers = useChatInputHandlers({
    config,
    chatContext,
    submitCallback,
    isLoading,
  });

  const { documentsCount, companiesCount, statistics } =
    useGetDocumentContextCounts({
      params,
      messages,
    });
  return (
    <ChatInputComposer
      ref={inputRef}
      handlers={handlers}
      config={{
        ...config,
        isLoading,
      }}
      contextCounts={{
        documentsCount,
        subTypeCount: companiesCount,
        statistics,
      }}
    />
  );
};
